export function logFormErrors(errorResponse, toast) {
    const isFormErrorsArray = Array.isArray(errorResponse?.response?.data?.formErrors)

    let arrmessage = ''
    if (isFormErrorsArray) {
        errorResponse?.response?.data?.formErrors?.forEach((e) => {
            console.log('e', e)
            arrmessage += `• ${e?.error?.errorCode?.errorCode || e?.error?.errorCode}: ${e?.error?.errorCode?.message || e?.error?.message}\n`;
        })
        if (toast) {
            toast(arrmessage);
        } else {
            console.error(arrmessage);
        }
        return
    }
    const errors = errorResponse?.response?.data?.formErrors?.errors;
    if (!errors) {
        if (toast) {
            toast("An unexpected error occurred.")
        } else {
            console.error("An unexpected error occurred.");
        }
        return;
    }

    let message = "Please fix the following errors:\n\n";
    for (const [field, errorMsg] of Object.entries(errors)) {
        message += `• ${field}: ${errorMsg}\n`;
    }

    if (toast) {
        toast(message);
    } else {
        console.error(message);
    }
}

export function formatISOToDateTimeString(date) {
    const asDate = new Date(date);
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Colombo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    }).formatToParts(asDate);

    const get = (type) => parts.find((part) => part.type === type)?.value || '00';
    return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}:${get('minute')}:${get('second')}`;
}

